import React from 'react';
import { Button, Layout as AntLayout, Avatar, Dropdown, Menu, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './layout.css';
import {
  DashboardOutlined,
  GlobalOutlined,
  UserOutlined,
  ProfileOutlined,
  LogoutOutlined,
  DownOutlined,
  BankOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  SolutionOutlined,
  TeamOutlined,
  RobotOutlined,
} from '@ant-design/icons';
import { canManageData, isAdmin } from '../../utils/roles';
import { signOutNow } from '../../utils/session';

const { Header, Content, Footer } = AntLayout;

const PageLayout = ({ children, immersive = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentUser } = useSelector((state) => state.user);
  const location = useLocation();
  const isImmersive =
    immersive || location.pathname.startsWith('/admin/team-assistant');

  const handleLogout = () => {
    signOutNow(dispatch, navigate);
  };

  const handleMenuClick = (key) => {
    if (key === 'logout') {
      handleLogout();
    } else {
      navigate(key);
    }
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="/profile" onClick={() => handleMenuClick('/profile')} icon={<ProfileOutlined />}>
        Profile Settings
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" onClick={() => handleMenuClick('logout')} icon={<LogoutOutlined />}>
        Sign Out
      </Menu.Item>
    </Menu>
  );

  const companyMenu = (
    <Menu>
      <Menu.Item key="/admin/companies" onClick={() => handleMenuClick('/admin/companies')} icon={<BankOutlined />}>
        Companies
      </Menu.Item>
      <Menu.Item key="/admin/line-of-business" onClick={() => handleMenuClick('/admin/line-of-business')} icon={<AppstoreOutlined />}>
        Line of Business
      </Menu.Item>
    </Menu>
  );

  const jobMenu = (
    <Menu>
      <Menu.Item key="/admin/jobs" onClick={() => handleMenuClick('/admin/jobs')} icon={<FileTextOutlined />}>
        Jobs
      </Menu.Item>
      <Menu.Item key="/admin/job-type" onClick={() => handleMenuClick('/admin/job-type')} icon={<SolutionOutlined />}>
        Job Type
      </Menu.Item>
    </Menu>
  );

  return (
    <AntLayout className={isImmersive ? 'layout layout--immersive' : 'layout'}>
      <Header className="layout-header">
        <div className="header-left">
          <div className="logo" onClick={() => navigate('/')}> 
            <BankOutlined className="logo-icon" />
            <span className="logo-text">Market Finder</span>
          </div>

          {currentUser && (
            <div className="nav-menu">
              {canManageData(currentUser) && (
                <>
                  <Button type="text" icon={<GlobalOutlined />} onClick={() => handleMenuClick('/')} className="nav-button">
                    Visit Frontend
                  </Button>

                  {isAdmin(currentUser) && (
                    <Button type="text" icon={<DashboardOutlined />} onClick={() => handleMenuClick('/dashboard')} className="nav-button">
                      Dashboard
                    </Button>
                  )}

                  
<Button
                    type="text"
                    icon={<RobotOutlined />}
                    onClick={() => handleMenuClick('/admin/team-assistant')}
                    className="nav-button"
                  >
                    Team assistant
                  </Button>

                  <Dropdown overlay={companyMenu} trigger={['click']}>
                    <Button type="text" className="nav-button">
                      Companies <DownOutlined />
                    </Button>
                  </Dropdown>

                  {/* <Dropdown overlay={jobMenu} trigger={['click']}>
                    <Button type="text" className="nav-button">
                      Jobs <DownOutlined />
                    </Button>
                  </Dropdown> */}

                  

                  {isAdmin(currentUser) && (
                    <Button type="text" icon={<TeamOutlined />} onClick={() => handleMenuClick('/admin/users')} className="nav-button">
                      Users
                    </Button>
                  )}

                </>
              )}
            </div>
          )}
        </div>

        {currentUser && (
          <div className="header-right">
            <Dropdown overlay={userMenu} trigger={['click']}>
              <Space className="user-dropdown">
                <Avatar icon={<UserOutlined />} src={currentUser.profile_picture} className="user-avatar" />
                <span className="user-name">{currentUser.name}</span>
                <DownOutlined />
              </Space>
            </Dropdown>
          </div>
        )}
      </Header>

      <Content className={`layout-content${isImmersive ? ' layout-content--immersive' : ''}`}>
        <div className={`content-wrapper${isImmersive ? ' content-wrapper--immersive' : ''}`}>
          {children}
        </div>
      </Content>

      {!isImmersive && (
        <Footer className="layout-footer">
          <div className="footer-content">
            <div className="footer-copyright">©2024 Market Finder. All rights reserved.</div>
          </div>
        </Footer>
      )}

    </AntLayout>
  );
};

export default PageLayout;